import { BaseOrderEntity, IBaseOrder } from './base-order.model';
import { OfflineOrderState, OfflineSendStrategy } from '../../../offline-ipo';
import { OrderModelType, OrderStateClasses, StateNotificationColorClass } from '../../../../constants';
import { IBaseEntity } from '../../../shared/models/base.model';
import { EasyState } from './orderModels.model';

export class OfflineOrder extends BaseOrderEntity<OfflineOrder> {
	constructor(obj: Partial<OfflineOrder>) {
		super(obj);
		Object.assign(this, obj);
		this.orderModelType = OrderModelType.offline;
	}
	state?: OfflineOrderState;
	errorType?: number;
	sendStrategy?: OfflineSendStrategy;
	requestModel;
	responseModel;
	get IsOfflineError(): boolean {
		return this.state === OfflineOrderState.Error;
	}
	get StateClass() {
		return this.easyState === EasyState.Done ? OrderStateClasses.Offline : OrderStateClasses.Disabled;
	}
	symbolName?: string;

	get StateNotificationClass() {
		return this.StateNotificationColorClass;
	}
	get StateNotificationColorClass() {
		if (this.IsOfflineError) return StateNotificationColorClass.Error;
		return StateNotificationColorClass.Offline;
	}
	get StateNotificationText() {
		if (this.IsOfflineError) return 'خطا';
		return 'ثبت آفلاین';
	}

	get IsSelectable() {
		return false;
	}
}

export interface IOfflineOrderUpdateRequest extends IBaseEntity, IBaseOrder {}
export interface IOfflineOrderUpdateResponse extends IBaseEntity, IBaseOrder {}
export type IOfflineOrderCreateRequest = IBaseOrder;
export interface IOfflineOrderCreateResponse extends IBaseEntity, IBaseOrder {}
export type IOfflineOrderDeleteRequest = IBaseEntity;
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IOfflineOrderDeleteResponse {}
